<!-- components/PopupBanner.vue -->
<template>
  <Teleport to="body">
    <div v-if="showPopup" class="popup-overlay" @click.self="closePopup">
      <div class="popup-modal">
        <button class="popup-close" @click="closePopup">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        </button>
        
        <router-link to="/mypage/event" class="popup-content" @click="closePopup">
          <img src="@/assets/popupbanner.png" alt="이벤트 배너" />
        </router-link>
        
        <div class="popup-footer">
          <label class="dont-show-today">
            <input type="checkbox" v-model="dontShowToday" />
            <span>오늘 하루 보지 않기</span>
          </label>
          <button class="btn-close" @click="closePopup">닫기</button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { ref, onMounted } from 'vue'

export default {
  name: 'PopupBanner',
  setup() {
    const showPopup = ref(false)
    const dontShowToday = ref(false)
    const STORAGE_KEY = 'popup_hidden_date'

    const isHiddenToday = () => {
      const hiddenDate = localStorage.getItem(STORAGE_KEY)
      if (!hiddenDate) return false
      const today = new Date().toISOString().split('T')[0]
      return hiddenDate === today
    }

    const closePopup = () => {
      if (dontShowToday.value) {
        const today = new Date().toISOString().split('T')[0]
        localStorage.setItem(STORAGE_KEY, today)
      }
      showPopup.value = false
    }

    onMounted(() => {
      if (!isHiddenToday()) {
        showPopup.value = true
      }
    })

    return {
      showPopup,
      dontShowToday,
      closePopup
    }
  }
}
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  backdrop-filter: blur(4px);
}

.popup-modal {
  position: relative;
  background: #fff;
  border-radius: 16px;
  max-width: 400px;
  width: 100%;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: popup-in 0.3s ease;
}

@keyframes popup-in {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.popup-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  z-index: 10;
}

.popup-close:hover {
  background: rgba(0, 0, 0, 0.7);
}

.popup-content {
  display: block;
}

.popup-content img {
  width: 100%;
  height: auto;
  display: block;
}

.popup-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: #f9fafb;
  border-top: 1px solid #e5e8eb;
}

.dont-show-today {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #6b7684;
  cursor: pointer;
}

.dont-show-today input {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.btn-close {
  padding: 8px 16px;
  background: #191f28;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-close:hover {
  background: #333d4b;
}

@media (max-width: 480px) {
  .popup-modal {
    max-width: 320px;
  }

  .popup-footer {
    padding: 12px 14px;
  }

  .dont-show-today {
    font-size: 12px;
  }
}
</style>